import React, {FC, HTMLAttributes, useEffect, useRef, useState} from "react";
import {Select} from "antd";
import {OptionProp} from "./interfaces/OptionProp";
import classNames from 'classnames/bind';
import css from './SelectGroup.module.scss';
import {useDetectOutsideClick} from "../../hooks/useDetectOutsideClick";


interface SelectGroupProps extends HTMLAttributes<typeof Select> {
    options: OptionProp[] | string[],
    defaultOption: OptionProp | string;
    handleChange: (value: React.MouseEvent<HTMLLIElement, MouseEvent>) => void
}

const cx = classNames.bind(css);

const SelectGroup: FC<SelectGroupProps> = ({defaultOption, options, handleChange, className}) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [selected, setSelected] = useState<OptionProp | string>(defaultOption);
    const optionsBox = useRef<HTMLDivElement>(null);
    const isOutsideClick = useDetectOutsideClick(optionsBox);

    useEffect(() => {
        if (isOutsideClick) {
            setIsOpen(false);
        }
    })

    const parseOption = (option: string | OptionProp): OptionProp => {
        if (typeof option === 'string') {
            return {
                id: option,
                option: option
            }
        }
        return option;
    }

    const toggle = () => {
        setIsOpen(prevState => !prevState);
    }

    const handleSelect = (event: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
        setSelected({id: Number(event.currentTarget.value), option: event.currentTarget.textContent || ''});
        handleChange(event);
        setIsOpen(false);
    }

    return (
        <div ref={optionsBox} className={cx(css.wrapper)}>
            <select className={cx(css.hidden)}>
                {options.map(op => (
                    <option className={css.select__option} key={parseOption(op).id}>
                        {parseOption(op).option}
                    </option>
                ))}
            </select>
            <div className={cx(css.customSelect, {open: isOpen})} onClick={toggle}>
                {parseOption(selected).option}
            </div>
            <ul className={cx(css.options, {hidden: !isOpen})}>
                {options.map(op => (
                    <li onClick={handleSelect} key={parseOption(op)!.id} value={parseOption(op).id}
                        className={cx(css.options__option)}>
                        {parseOption(op).option}
                    </li>
                ))
                }
            </ul>
        </div>
    )
}

export default SelectGroup;
